import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'amobee-loader',
    templateUrl: './amobee-loader.component.html',
    styleUrls: [ './amobee-loader.component.scss' ]
})
export class AmobeeLoaderComponent implements OnInit {
    @Input() public loading: boolean;
    @Input() public alternate: boolean = true;
    @Input() public scale: boolean = true;
    @Input() public size: string;

    public dark;

    constructor() {}

    public ngOnInit(): void {}
}
